import * as yup from 'yup';

export default yup.object().shape({
  __typename: yup.string().strip(true),
});
